import React from 'react';
import styled from 'styled-components';

interface ContentSectionProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  className?: string;
}

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Icon = styled.img`
  width: 34px;
  height: 34px;
  @media (min-width: 768px) {
    width: 54px;
    height: 54px;
  }
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.25rem;
`;

const Content = styled.div`
  color: #7A7A7A;
`;

export const ContentSection: React.FC<ContentSectionProps> = ({
  title,
  icon,
  children,
  className,
}) => {
  return (
    <Section className={className}>
      {icon && <Icon src={icon} alt={title} />}
      <Title>{title}</Title>
      <Content>{children}</Content>
    </Section>
  );
};